// A one-way "the session ended, go back to sign-in" signal. The API client can
// detect an unrecoverable auth failure (refresh missing/expired) deep in a fetch,
// far from React; this decouples that detection from the UI's reaction. The app
// subscribes; the client publishes. Storage is cleared here so every listener
// observes a consistent signed-out state.
import { tokenStore } from "./tokenStore";

const SESSION_EXPIRED_EVENT = "a8:session-expired";

/** Clear credentials and notify subscribers that the user must sign in again. */
export function expireSession(): void {
  tokenStore.clear();
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
}

/** Subscribe to session expiry; returns an unsubscribe function. */
export function onSessionExpired(handler: () => void): () => void {
  window.addEventListener(SESSION_EXPIRED_EVENT, handler);
  return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
}
